module.exports = __webpack_public_path__ + "img/mengantar-logo.a91fc5c2.svg";